<script setup>
import helpers from "@/lib/helpers";
import {onMounted, ref} from "vue"
import WarehouseForm from "./warehouse-form.vue";

const warehouses = ref([])
const edit = ref(false)

const refresh = () => helpers.asyncAction('/api/warehouse', 'GET', {params: {deleted: true}}).then(v => warehouses.value = v)

onMounted(() => refresh())

const done = () => {
  edit.value = null
  refresh()
}

const delete_whse = async (warehouse) => {
  if (await helpers.confirm('Delete this warehouse?')) {
    helpers.asyncAction(warehouse._links.delete_url).then(() => {
      helpers.toast('Warehouse deleted')
      refresh()
    })
  }
}

const click_whse = async (warehouse) => {
  if (warehouse.deleted) {
    if (await helpers.confirm('Restore warehouse?')) {
      await helpers.asyncAction('/api/warehouse', 'POST', {data: {_restore: warehouse.id}})
      helpers.toast('Warehouse restored')
      await refresh()
    } else
      return

  }
  edit.value = warehouse
}
</script>

<template>
  <modal title="Warehouses" height="300px">
    <template #buttons>
      <b-button v-if="!!edit" variant="link" class="text-white d-none d-sm-inline" size="sm" @click="refresh(); edit = null">BACK
      </b-button>
      <b-button v-else-if="can('warehouses.create')" variant="link" class="text-white d-none d-sm-inline" size="sm"
                @click="edit = true">NEW
      </b-button>

    </template>

    <warehouse-form v-if="!!edit" :value="edit" @done="done"/>

    <b-list-group v-else>
      <b-list-group-item button v-for="warehouse in warehouses" :key="warehouse.id"
                         @click="click_whse(warehouse)"
                         class="d-flex" :variant="warehouse.deleted ? 'danger' : null">
        <div class="mr-auto">
          <h3>{{ warehouse.name }}</h3>
          <div>{{ warehouse.gli }}:  {{ warehouse.desc }}</div>
          <div class="font-weight-bold" v-if="warehouse.deleted">Deleted on {{ warehouse.deleted }}</div>
        </div>
        <div class="my-auto ml-3" v-if="can('warehouses.delete') && !warehouse.deleted">
          <b-btn @click.stop="delete_whse(warehouse)" variant="danger">
            <font-awesome-icon :icon="['fas', 'trash-can']"/>
          </b-btn>
        </div>
      </b-list-group-item>
    </b-list-group>
  </modal>
</template>

<style scoped>

</style>